import { render, staticRenderFns } from "./ImagePopover.vue?vue&type=template&id=e18c958c&"
import script from "./ImagePopover.vue?vue&type=script&lang=js&"
export * from "./ImagePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports